import { Select } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

export const FILTER_KEY = 'applicability' as const;

/** Filters evidence fields by their exclusive consumer. */
export default function EvidenceFieldApplicabilitySelectFilter({
  api,
  onChange,
}: {
  api: GridApi;
  onChange?: FilterChangeCallback;
}) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange, type: 'equals' });
  return (
    <Select
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky použitia"
      data={[
        { value: 'devices', label: 'Zariadenia' },
        { value: 'people', label: 'Osoby' },
      ]}
      value={value}
      onChange={setValue}
    />
  );
}
